import Util from '@/helper/Utility.js';
export default {
    install (Vue) {
        Vue.filter('number_format', function(value) {
            var num = parseInt(value, 10);
            return Util.formatNum(num, 0)
        });
        Vue.filter('phone_format', function(value) {
            if (value == null) {
                return '';
            }
            var str = Util.contactNumberFormat(value, '-');
            return str;
        });
        Vue.filter('date_format', function(timestamp) {
            // Format : DD MMM YYYY
            return Util.dateFormat(timestamp);
        });
        Vue.filter('date_time_format', function(timestamp) {
            // Format : DD MM YYYY - hh:mm
            return Util.dateTimeFormat(timestamp);
        });
    }
};